<div class="dl-page dl-page--narrow">
  <!-- Header -->
  <button type="button" class="dl-page__back" (click)="onCancel()">
    <mat-icon>chevron_left</mat-icon>
    Back
  </button>

  <div class="dl-page__header">
    <div class="dl-page__heading">
      <h1 class="dl-page__title">Edit Partner</h1>
    </div>
  </div>

  <!-- Loading indicator -->
  <div *ngIf="loading" class="dl-loading">
    <div class="dl-spinner"></div>
    <p>Loading partner details...</p>
  </div>

  <!-- Error message -->
  <div *ngIf="error && !loading" class="dl-banner dl-banner--error">
    <p>
      <mat-icon>error</mat-icon>
      {{ error }}
    </p>
    <button (click)="onCancel()">
      <mat-icon>arrow_back</mat-icon>
      Back to Partner Details
    </button>
  </div>

  <!-- Success message -->
  <div *ngIf="success" class="dl-banner dl-banner--success">
    <p>
      <mat-icon>check_circle</mat-icon>
      Partner updated successfully! Redirecting to partner details...
    </p>
  </div>

  <!-- Edit Partner Form -->
  <div *ngIf="partner && !loading && !error && !success" class="edit-form">
    <div class="dl-card">
      <h2>
        <mat-icon>edit</mat-icon>
        Edit Partner Information
      </h2>

      <!-- Partner Type Display (Read-only) -->
      <div class="partner-type-display">
        <label>Partner Type</label>
        <div class="readonly-field">
          <span class="partner-type" [class]="'type-' + (partner.type || 'unknown').toLowerCase()">
            {{ getPartnerTypeLabel() }}
          </span>
          <small>Partner type cannot be changed</small>
        </div>
      </div>

      <!-- Partner Logo -->
      <div class="partner-logo-section">
        <label>Partner Logo</label>
        <app-file-upload
          acceptedTypes="image/*"
          [maxSize]="5242880"
          placeholder="Drag & drop logo image here or click to select"
          [currentFile]="logoAttachment"
          [disabled]="saving"
          (fileSelected)="onLogoFileSelected($event)"
          (uploadCompleted)="onLogoUploadCompleted($event)"
          (uploadError)="onLogoUploadError($event)"
          (fileRemoved)="onLogoRemoved()">
        </app-file-upload>
        
        <!-- Pending upload indicator -->
        <div *ngIf="pendingLogoAttachment && !logoAttachment" class="pending-upload">
          <mat-icon>cloud_upload</mat-icon>
          <span>Logo uploaded successfully! Click "Save Changes" to apply.</span>
        </div>
      </div>

      <form (ngSubmit)="onSubmit()" #editForm="ngForm">
        <!-- Contact Information -->
        <div class="dl-card">
          <h3>
            <mat-icon>contact_phone</mat-icon>
            Contact Information
          </h3>
          
          <div class="dl-filters">
            <div class="dl-field">
              <label class="dl-field__label" for="name">Partner Name *</label>
              <input 
                type="text" 
                id="name" 
                name="name"
                [(ngModel)]="partnerForm.contact.name" 
                required
                placeholder="Enter partner name"class="dl-input">
            </div>

            <div class="dl-field">
              <label class="dl-field__label" for="email">Email Address *</label>
              <input 
                type="email" 
                id="email" 
                name="email"
                [(ngModel)]="partnerForm.contact.email" 
                required
                placeholder="Enter email address"class="dl-input">
            </div>

            <div class="dl-field">
              <label class="dl-field__label" for="phoneNumber">Phone Number *</label>
              <input 
                type="tel" 
                id="phoneNumber" 
                name="phoneNumber"
                [(ngModel)]="partnerForm.contact.phoneNumber" 
                required
                placeholder="Enter phone number"class="dl-input">
            </div>

            <div class="dl-field">
              <label class="dl-field__label" for="faxNo">Fax Number</label>
              <input 
                type="tel" 
                id="faxNo" 
                name="faxNo"
                [(ngModel)]="partnerForm.faxNo" 
                placeholder="Enter fax number"class="dl-input">
            </div>
          </div>
        </div>

        <!-- Address Information -->
        <div class="dl-card">
          <h3>
            <mat-icon>location_on</mat-icon>
            Address Information
          </h3>
          
          <div class="dl-filters">
            <div class="dl-field dl-filters__wide">
              <label class="dl-field__label" for="street">Street Address</label>
              <input 
                type="text" 
                id="street" 
                name="street"
                [(ngModel)]="partnerForm.contact.address.street" 
                placeholder="Enter street address"class="dl-input">
            </div>

            <div class="dl-field">
              <label class="dl-field__label" for="city">City</label>
              <input 
                type="text" 
                id="city" 
                name="city"
                [(ngModel)]="partnerForm.contact.address.city" 
                placeholder="Enter city"class="dl-input">
            </div>

            <div class="dl-field">
              <label class="dl-field__label" for="state">State</label>
              <input 
                type="text" 
                id="state" 
                name="state"
                [(ngModel)]="partnerForm.contact.address.state" 
                placeholder="Enter state"class="dl-input">
            </div>

            <div class="dl-field">
              <label class="dl-field__label" for="zip">ZIP Code</label>
              <input 
                type="text" 
                id="zip" 
                name="zip"
                [(ngModel)]="partnerForm.contact.address.zip" 
                placeholder="Enter ZIP code"class="dl-input">
            </div>
          </div>
        </div>

        <!-- Bank Accounts Information -->
        <div class="dl-card">
          <h3>
            <mat-icon>account_balance</mat-icon>
            Bank Accounts
          </h3>
          
          <div class="bank-accounts-list">
            <div *ngFor="let bankAccount of partnerForm.bankAccounts; let i = index" class="bank-account-item">
              <div class="bank-account-fields">
                <div class="dl-field">
                  <label class="dl-field__label" [for]="'bankName_' + i">Bank Name</label>
                  <input
                    type="text"
                    [id]="'bankName_' + i"
                    [(ngModel)]="bankAccount.name"
                    [name]="'bankName_' + i"
                    placeholder="Enter bank name"class="dl-input">
                </div>
                <div class="dl-field">
                  <label class="dl-field__label" [for]="'bankNumber_' + i">Account Number</label>
                  <input
                    type="text"
                    [id]="'bankNumber_' + i"
                    [(ngModel)]="bankAccount.number"
                    [name]="'bankNumber_' + i"
                    placeholder="Enter account number"class="dl-input">
                </div>
              </div>
              <button 
                type="button" 
                class="dl-btn dl-btn--danger-ghost dl-btn--icon dl-btn--sm" 
                (click)="removeBankAccount(i)" 
                [disabled]="saving"
                matTooltip="Remove bank account">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </div>
          
          <button 
            type="button" 
            class="dl-btn dl-btn--sm" 
            (click)="addBankAccount()" 
            [disabled]="saving">
            <mat-icon>add</mat-icon>
            Add Bank Account
          </button>
        </div>

        <!-- Form Actions -->
        <div class="form-actions">
          <button type="button" class="dl-btn" (click)="onCancel()" [disabled]="saving">
            <mat-icon>cancel</mat-icon>
            Cancel
          </button>
          <button type="button" class="dl-btn dl-btn--ghost" (click)="resetForm()" [disabled]="saving">
            <mat-icon>refresh</mat-icon>
            Reset
          </button>
          <button type="submit" class="dl-btn dl-btn--primary" [disabled]="saving">
            <mat-icon *ngIf="!saving">save</mat-icon>
            <mat-icon *ngIf="saving" class="form-spin">hourglass_empty</mat-icon>
            <span *ngIf="!saving">Save Changes</span>
            <span *ngIf="saving">Saving...</span>
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
